'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, event_id, adj_id) {
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return function (dispatch) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      event_id: event_id,
      adj_id: adj_id

    }, _middleware.CALL_API, {
      config: {
        url: '' + (0, _paths.scoresheetByAdjudicatorUrl)(feis_id, event_id, adj_id),
        method: 'POST',
        data: data
      },
      types: ['SET_SCORESHEET_STATUS_START', 'SET_SCORESHEET_STATUS', 'SET_SCORESHEET_STATUS_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/scoresheet/updateScoresheet.js
// module id = 677
// module chunks = 0